import type { Airflow, Shop } from '@aviata/platform-types';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export async function getOrderById({ orderId }: { orderId: string }) {
  try {
    const response = await api.shop.getOrderById(orderId);
    return response.data as Shop.Order.Entity<Airflow.Product.V2.Entity>;
  } catch (error) {
    sentryModel.logBaseError({
      error: error as Error,
      description: 'Payment error: failed to fetch order by id',
    });
  }
}
